

















































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import freightPopup from './freightPopup.vue';
import { findProduct, addTemplate, modifyTemplate, address, prohibitAddress, find } from '@/utils/api';
import { warning, success } from '@/utils/find';
import { filter } from 'vue/types/umd';

@Component({
  components: {
    freightPopup,
  },
})
export default class freightEdit extends Vue {
  disabledLoading: boolean = false; //确定按钮加载
  dialogVisible: boolean = false; //弹窗是否显示
  isAdd: boolean = true; //是否是新增按钮进来
  loading: boolean = false; //列表加载遮罩
  dialogTitle: string = '新增运费配置'; //弹窗title名称
  priceType: number = 0; //0按件数1按重量2按体积
  tableData: Array<Object> = []; //列表数据
  pieceList: Array<Object> = []; //按件数
  weightList: Array<Object> = []; //按重量
  volumeList: Array<Object> = []; //按体积
  addressList: Array<object> = []; //所有地址
  productData: object = { templateName: '' }; //内置价格详情数据
  freightPopupData: object = {}; //子组件数据
  handleAddress: Array<Object> = []; //已处理数据传给子组件
  prohibitAddress: Array<Object> = []; //禁止选择地址
  money: object = { initData: 0, initFreight: 0, continueData: 0, continueFreight: 0, topData: 0 }; //金额
  templateId: string = ''; //id
  @Prop(Object) data!: Object;
  @Watch('data', { immediate: true, deep: true })
  onPersonChanged(val: Object) {
    let data = val;
    (this.isAdd as boolean) = data['isadd'] as any as boolean;
    if (data['isadd']) {
      this.tableData = [];
      this.pieceList = []; //按件数
      this.weightList = []; //按重量
      this.volumeList = []; //按体积
    } else {
      let id = data['data']['templateId']; //修改传递过来id
      this.templateId = id;
      this.findProduct(id);
    }
    this.address(); //地址列表
    this.addressList = []; //所有地址
    this.handleAddress = []; //已处理数据传给子组件
    this.prohibitAddress = []; //禁止选择地址
  }
  // 查询单品详情
  findProduct(templateId) {
    this.loading = true;
    findProduct({
      templateId,
    })
      .then((data: any) => {
        this.productData = data;
        let templateType = data.templateType;
        this.priceType = templateType;
        let templateList = data.templateList;
        templateList.forEach((item) => {
          item['ids'] = Number(Math.random().toString().substr(3, 4) + Date.now());
        });
        if (templateType == 0) {
          this.pieceList = templateList;
          this.tableData = templateList;
        } else if (templateType == 1) {
          this.weightList = templateList;
          this.tableData = templateList;
        } else {
          this.volumeList = templateList;
          this.tableData = templateList;
        }
        this.prohibitAddressList(data.templateList);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  init() {
    this.productData['templateName'] = '' ;
  }
  // 地址列表
  address() {
    address().then((data: any) => {
      let address = data;
      let arr = [];
      address.forEach((item) => {
        (item['disable'] as boolean) = false;
        (item['isIndeterminate'] as boolean) = false;
        (item['checkAll'] as boolean) = false;
        (item['checkedCities'] as string[]) = [];
        (item['addressInfos'] as string[]) = [];
        (item['checkedCountLength'] as number) = 0;
        item.childList.forEach((ite) => {
          (ite['disable'] as boolean) = false;
        });
        arr.push(item as never);
      });
      this.addressList = arr;
    });
  }
  // 单选
  choice(val) {
    if (val == 0) {
      this.tableData = this.pieceList;
    } else if (val == 1) {
      this.tableData = this.weightList;
    } else {
      this.tableData = this.volumeList;
    }
  }
  // 单品模板删除
  delFreight(id) {
    let index = this.pieceList.findIndex((item) => item['ids'] == id.ids);
    this.pieceList.splice(index, 1);
    this.tableData = this.pieceList;
    this.address(); //地址列表
    this.prohibitAddressList(this.tableData);
  }
  // 新增
  added() {
    this.money = { initData: 0, initFreight: 0, continueData: 0, continueFreight: 0, topData: 0 }; //金额
    this.dialogTitle = '新增运费配置';
    let ban = this.prohibitAddress;
    let arr = this.addressList;
    if (ban.length == 0) {
      this.freightPopupData = {
        addressList: arr,
        money: this.money,
        ids: Number(Math.random().toString().substr(3, 4) + Date.now()),
        priceType: this.priceType,
      };
    } else {
      let ids = Number(Math.random().toString().substr(3, 4) + Date.now());
      this.handleAddressList(ban, arr, ids);
    }
    this.dialogVisible = true;
  }
  // 修改
  modify(data) {
    console.log(data);
    let ids = data.ids;
    let addressInfos = data.addressInfos;
    let initData = data.initData;
    let initFreight = data.initFreight;
    let continueData = data.continueData;
    let continueFreight = data.continueFreight;
    let topData = data.topData;
    this.money = { initData, initFreight, continueData, continueFreight, topData }; //金额
    let arr = this.addressList;
    let ban = this.prohibitAddress;
    this.handleAddressList(ban, arr, ids, addressInfos);
    this.dialogTitle = '修改运费配置';
    this.dialogVisible = true;
  }
  // 关闭弹窗初始化数据
  addressClose(done) {
    done();
    this.address(); //地址列表
  }
  // 取消弹框
  cancel() {
    this.dialogVisible = false;
    this.address(); //地址列表
  }
  // 子组件新增数据
  preserve(data) {
    console.log(data);

    let ids = data.ids;
    let index = (this.pieceList as Array<Object>).findIndex((item) => item['ids'] == ids);
    console.log(index);

    if (index == -1) {
      (this.pieceList as Array<Object>).push(data);
    } else {
      (this.pieceList as Array<Object>).splice(index, 1, data);
    }
    this.tableData = this.pieceList;
    this.dialogVisible = false;
    this.prohibitAddressList(this.tableData);
    this.address(); //地址列表
  }
  // 禁用地址处理
  prohibitAddressList(arr) {
    let arrs: Array<Object> = [];
    arr.forEach((item) => {
      item.addressInfos.forEach((ite) => {
        arrs.push(ite);
      });
    });
    this.prohibitAddress = arrs;
  }
  // 处理数据
  handleAddressList(ban, arr, ids, data?: any) {
    let bans = ban;
    if (data) {
      data.forEach((item) => {
        let ins = arr.findIndex((s) => s['addressId'] == item.provinceId);
        (arr[ins]['checkedCities'] as any).push(item.cityId);
        (arr[ins]['addressInfos'] as any).push(item);
      });
      arr.forEach((item) => {
        if ((item['checkedCities'] as any).length > 0) {
          if ((item['checkedCities'] as any).length == (item['childList'] as any).length) {
            (item['checkAll'] as boolean) = true;
            (item['isIndeterminate'] as boolean) = false;
          } else {
            (item['checkAll'] as boolean) = false;
            (item['isIndeterminate'] as boolean) = true;
          }
        }
      });
      bans = bans.filter((items) => {
        if (!data.includes(items)) return items;
      });
    }
    bans.forEach((i) => {
      let index = arr.findIndex((s) => s['addressId'] == i['provinceId']);
      let inds = (arr[index]['childList'] as any).findIndex((x) => x.addressId == i['cityId']);
      (arr[index]['childList'][inds]['disable'] as boolean) = true;
    });
    arr.forEach((item) => {
      let num = 0;
      (item['childList'] as any).forEach((o) => {
        if (o.disable == true) {
          num++;
        }
      });
      (item['disable'] as Boolean) = (item['childList'] as any).length == num ? true : false;
    });
    this.freightPopupData = { addressList: arr, money: this.money, ids, priceType: this.priceType };
  }
  // 确认操作
  saveData() {
    let templateName = this.productData['templateName']; //模板名称
    let tableData = this.tableData; //数据
    let priceType = this.priceType;
    let isAdd = this.isAdd;
    let defaulted = this.data['data']['defaulted'];
    let templateId = this.templateId;
    if (templateName == '') {
      warning('请输入模板名称', 1000);
    } else {
      if (isAdd) {
        if (tableData.length < 1) {
          warning('请新增运费配置', 1000);
        } else {
          this.disabledLoading = true;
          let data = {
            templateName,
            templateType: priceType,
            templateList: tableData,
            defaulted: 0,
          };
          this.addTemplate(data);
        }
      } else {
        let initData = this.productData['templateList'][0]['initData'];
        let initFreight = this.productData['templateList'][0]['initFreight'];
        let continueData = this.productData['templateList'][0]['continueData'];
        let continueFreight = this.productData['templateList'][0]['continueFreight'];
        let topData = this.productData['templateList'][0]['topData'];
        let data = {
          templateId,
          templateName,
          templateType: priceType,
          defaulted,
        };
        if (defaulted == 1) {
          if (initData == 0 || initFreight == 0 || continueData == 0 || continueFreight == 0 || topData == 0) {
            warning('运费设置金额和件数不能为0', 1000);
          } else {
            this.disabledLoading = true;
            data['templateList'] = [
              { id: this.productData['templateList'][0]['id'], initData, initFreight, continueData, continueFreight, topData },
            ];
            this.modifyTemplate(data);
          }
        } else {
          if (tableData.length < 1) {
            warning('请新增运费配置', 1000);
          } else {
            this.disabledLoading = true;
            data['templateList'] = tableData;
            this.modifyTemplate(data);
          }
        }
      }
    }
  }
  // 取消
  close() {
    this.$emit('replace');
  }
  // 编辑接口
  modifyTemplate(data) {
    modifyTemplate(data)
      .then((data) => {
        success('单品运费模板修改成功');
        this.$emit('replace');
      })
      .finally(() => {
        this.disabledLoading = false;
      });
  }
  // 新增接口
  addTemplate(data) {
    addTemplate(data)
      .then((data) => {
        success('新增单品运费模板成功');
        this.$emit('replace');
      })
      .finally(() => {
        this.disabledLoading = false;
      });
  }
}
